//import { BrowserRouter, Route, Routes } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GlobalProvider, Layout } from '@/store';
import { ConfirmModal, ErrorModal, SuccessModal, Toast, ProtectedRoute, PProAuthWall } from '@/components';
import { Account, Description, Mind, History, Home, Intake, Results, PhysicalSymptom, LandingPage } from '@/views';
import { usePatientSync } from '@/store/usePatientSync';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PaymentGateway from './components/PaymentGateway';
import SuccessPage from './views/SuccessPage';
import CancelPage from './views/CancelPage';

const queryClient = new QueryClient();

function AppContent() {
  usePatientSync();

  const basename =
    typeof window !== 'undefined' && window.location.pathname.startsWith('/ppro')
      ? '/ppro'
      : '/';

  return (
    <BrowserRouter basename={basename}>
      <PProAuthWall />
      <Layout>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<Home />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/account" element={<Account />} />
            <Route path="/intake" element={<Intake />} />
            <Route path="/description" element={<Description />} />
            <Route path="/physical-symptom" element={<PhysicalSymptom />} />
            <Route path="/mind" element={<Mind />} />
            <Route path="/results" element={<Results />} />
            <Route path="/history" element={<History />} />
            
            {/* Rutas de Pago */}
            <Route path="/payment" element={<PaymentGateway />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/cancel" element={<CancelPage />} />
          </Route>
        </Routes>
        <Toast />
        <ErrorModal />
        <ConfirmModal />
        <SuccessModal />
      </Layout>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <GlobalProvider>
      <QueryClientProvider client={queryClient}>
        <AppContent />
      </QueryClientProvider>
    </GlobalProvider>
  );
}